import classNames from 'classnames';
import React, { Component } from 'react';
import './Footer.css';
// import { isModal } from '../../../routesMap';

// Props
// nextName: string;
// nextDisabled: boolean;
// nextHidden?: boolean;
// handleClickNext: () => void;
// prevName: string;
// prevDisabled: boolean;
// handleClickPrev: () => void;

export default class Footer extends Component {

  onClickPrev = () => {
    if (!this.props.prevDisabled) {
      this.props.handleClickPrev();
      // if (isModal || this.props.isLocationSelection || this.props.isPartyRoomSelection) this.props.handleClickPrev();
      // else window.history.back();
    }
  }

  onClickNext = () => {
    if (this.props.nextDisabled === false) this.props.handleClickNext();
  }

  render() {
    const prevClassNames = classNames('FooterPrev', {
      'FooterPrev--disabled': this.props.prevDisabled
    });
    const nextClassNames = classNames('FooterNext', {
      'FooterNext--disabled': this.props.nextDisabled
    });
    const pulseClassNames = classNames('FooterPulse', {
      'FooterPulse--disabled': this.props.nextDisabled
    });

    return (
      <div className={'Footer'}>
        {!this.props.prevHidden && (
          <div className={prevClassNames} onClick={this.onClickPrev}>
            <img alt={'Arrow Left'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowLeft.png`} />
            {this.props.prevName}
          </div>
        )}

        <div className={'FooterSpacer'}>{}</div>

        {!this.props.nextHidden && (
          <div className={nextClassNames} onClick={this.onClickNext}>
            <div className={pulseClassNames}>
              {this.props.nextName}
              <img alt={'Arrow Right'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowRight.png`} />
            </div>
          </div>
        )}

      </div>
    );
  }
}
